function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st0{fill:#11BBEE}.action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st1{fill:#77CC44}.action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st2{fill:#FFFFFF}.action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st3{fill:#FF5533}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st0",
  d: "M66.4,18.7c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4v12.8c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.9 V6.8c0-1.9-1.5-3.4-3.4-3.4s-3.4,1.5-3.4,3.4V28c0,0.5-0.4,0.9-0.8,0.9c-0.5,0-0.8-0.4-0.8-0.9V3.4C49.4,1.5,47.9,0,46,0 s-3.4,1.5-3.4,3.4V28c0,0.5-0.4,0.9-0.8,0.9c-0.5,0-0.8-0.4-0.8-0.9V8.5c0-1.9-1.5-3.4-3.4-3.4s-3.4,1.5-3.4,3.4V34l1.6-1.6 c1-1,2.2-1.5,3.6-1.5c1.4,0,2.6,0.5,3.6,1.5c2,2,2,5.2,0,7.2l-9.7,9.7l4.2,4.2c3.1,3.1,7.3,5,12,5c9.4,0,17-7.6,17-16.9L66.4,18.7 L66.4,18.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st1",
  d: "M0,18.7c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4v12.8c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.9-0.4,0.9-0.9V6.8 c0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4V28c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9V3.4C17,1.5,18.6,0,20.5,0 c1.9,0,3.4,1.5,3.4,3.4V28c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V8.5c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4V34l-1.6-1.6 c-1-1-2.2-1.5-3.6-1.5s-2.6,0.5-3.6,1.5c-2,2-2,5.2,0,7.2l9.7,9.7L29,53.4c-3.1,3.1-7.3,5-12,5c-9.4,0-17-7.6-17-16.9V18.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st2",
  d: "M33.2,49.2l-9.7-9.7c-2-2-2-5.2,0-7.2c1-1,2.2-1.5,3.6-1.5s2.6,0.5,3.6,1.5l2.5,2.5l2.5-2.5 c1-1,2.2-1.5,3.6-1.5c1.4,0,2.6,0.5,3.6,1.5c2,2,2,5.2,0,7.2L33.2,49.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__st3",
  d: "M42.1,38.7c1.5-1.5,1.5-4,0-5.6s-4-1.5-5.6,0l-3.3,3.3l-3.3-3.3c-1.5-1.5-4-1.5-5.6,0s-1.5,4,0,5.6l8.9,8.9 L42.1,38.7z"
});

function SvgActionOppsVolunteermatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "action-opps-volunteermatch_svg__action-opps-volunteermatch_svg__vmlogo",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.4 58.4",
    style: {
      enableBackground: "new 0 0 66.4 58.4"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgActionOppsVolunteermatch;